import firebase               from    'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

export const firebaseConfig = {
    apiKey: "AIzaSyAMfPy6Kqa7BeX5DYMOZfowbVHLevYhcNQ",
    authDomain: "invoice-app-exe-dev.firebaseapp.com",
    databaseURL: "https://invoice-app-exe-dev.firebaseio.com",
    projectId: "invoice-app-exe-dev",
    storageBucket: "invoice-app-exe-dev.appspot.com",
    messagingSenderId: "860002131322",
    appId: "1:860002131322:web:cf2930e6706b5ae3fe0ac3",
    measurementId: "G-0TLJ2KNGGF"
};

export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const VERIFY_GST_API_SECRET_KET = '40JLtFU9EhSSvp3GFB301Vqn6Kv1';

export const USE_GST_VERIFY = false;